<template>
<div class="image-view"
    @touchstart="listen__view__on_x_down($event, 'touch')"
    @mousedown="listen__view__on_x_down($event, 'mouse')"
    @wheel="listen__view__onwheel">
  <frame
    style="background:rgba(0, 0, 0, 0);"
    ref="frame"
    :frame-data="frameData"
    :pred="[]"
    :initial-tool-option="{ mouseButtonMask: 2, tools: ['Crop']}"
    :mode="mode"
    :tool-options="toolOptions"
    @onstatechange="listen__frame__onstatechange"
    @onadd="(data) => {this.$emit('onadd', data)}" />
</div>
</template>

<script>


import Frame from '@/components/imageprocessingdialog/Frame.vue'

export default {
  props: {
    mode: String,
    frameData: Object,
    type: Number,
    initialFrameState: Object,
    initialToolOption: Object,
    toolOptions: Object
  },
  data: function () {
    return {
    }
  },
  components: {
    Frame
  },
  methods: {
    listen__view__on_x_down: function (e, type) {
      this.$refs['frame'].listen__view__on_x_down(e, type);
    },
    listen__view__onwheel: function (e) {
      this.$refs['frame'].listen__view__onwheel(e);
    },
    listen__frame__onstatechange: function (data) {
      this.$emit('onstatechange', data)
    },
    tostatechange: function (data) {
      this.$refs['frame'].listen__state__tochange(data)
    },
    fitToWindow() {
      this.$refs['frame'].fitToWindow()
    },
    clearToolState: function (toolName) {
      const Vue = this
      Vue.$refs['frame'].clearToolState(toolName)
    },
    setCropMode: function () {
      const Vue = this
      Vue.$refs['frame'].setCropMode()
    },
    update: function () {
      const Vue = this
      Vue.$refs['frame'].update()
    }
  }
}
</script>

<style scoped>
.image-view {
  display: block;
  position: relative;
  background-color: #f0f0f0;
  background-image: 
    linear-gradient(45deg,#e0e0e0 25%,transparent 0,transparent 75%,#e0e0e0 0,#e0e0e0),
    linear-gradient(45deg,#e0e0e0 25%,transparent 0,transparent 75%,#e0e0e0 0,#e0e0e0);
  background-size: 40px 40px;
  background-position: 0 0,20px 20px;
  background-position-x: 0px, 20px;
  background-position-y: 0px, 20px;
  overflow: hidden;
}
</style>